<template>
  <centered-box>
    <message v-if="error" class="is-danger"> {{ $t(error) }} </message>
    <h3 class="title is-size-3 is-size-5-mobile has-text-centered">
      {{ $t("Welcome to chefCarte")
      }}<span v-if="isDemoEnv">,<br />{{ $t("try it out, it's easy!") }} </span>
    </h3>

    <h4 class="welcome-subtitle title is-6" v-if="isDemoEnv">
      {{ $t("Log in with Google or create your account.") }}<br />
    </h4>
    <div class="is-p1 is-pt-small">
      <button class="button is-fullwidth" @click="loginWithGoogle">
        {{ $t("Log in with Google") }}
      </button>
    </div>
    <div class="is-p1">
      <router-link tag="button" class="button is-fullwidth" to="/login-email">
        {{ $t("Log in with Email") }}
      </router-link>
    </div>
    <p class="signup-message">
      {{ $t("You don't have an account? You can") }}
      <router-link to="/sign-up">{{ $t("create one") }}</router-link>
    </p>
    <p class="legal-message">
      {{ $t("If interested, take a look at our") }}
      <a href="https://chefcarte.com/res/doc/gdpr.pdf" target="_blank">
        {{ $t("Privacy Policy document") }}
      </a>
    </p>
  </centered-box>
</template>

<script>
import { CenteredBox } from "@/components/layout"
import { actions, state } from "@/store"
import message from "@/components/message"

export default {
  name: "login",
  components: {
    CenteredBox,
    message
  },
  data() {
    return {
      error: undefined
    }
  },
  computed: {
    isDemoEnv() {
      return state.isDemoEnv
    }
  },
  methods: {
    loginWithGoogle() {
      actions
        .loginWithGoogle()
        .then(() => {
          this.$router.push("/")
        })
        .catch(e => {
          this.error = "google-auth-error"
          this.$logger.error(this.error, e)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/style.scss";

.welcome-title {
  text-align: center;
  padding: 0.5rem 1rem;
}
.welcome-subtitle {
  text-align: center;
  margin-top: 3rem;
  margin-bottom: 0.5rem;
  @include mobile {
    margin-top: 2rem;
    margin-bottom: 1rem;
  }
}
.signup-message {
  text-align: center;
  margin-top: 0.5rem;
}
.legal-message {
  text-align: center;
  margin-top: 2rem;
}
</style>
